import { render, staticRenderFns } from "./ListWaiting.vue?vue&type=template&id=6bc8f834&scoped=true&"
import script from "./ListWaiting.vue?vue&type=script&lang=js&"
export * from "./ListWaiting.vue?vue&type=script&lang=js&"
import style0 from "./ListWaiting.vue?vue&type=style&index=0&id=6bc8f834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc8f834",
  null
  
)

export default component.exports